import {
  jb_location_overview_css_default
} from "./chunk.3ZC3NMXF.js";
import {
  o
} from "./chunk.BLBOUOUQ.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-location-overview/jb-location-overview.ts
var JbLocationOverview = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { colsMdUp: 12, colsLgUp: 12, grid: true };
  }
  render() {
    return b`
      <div class="wrapper">
        ${this.regions.map(
      (region) => b`<div class="region-wrapper">
              <jb-heading class="region-title">${region.title}</jb-heading>
              ${region.countries.map((country) => {
        const isSingle = country.locations.length === 1;
        return b`<jb-heading
                    class="country-title"
                    offset="1"
                    >${country.title}</jb-heading
                  >
                  <ul
                    class="country-wrapper"
                    aria-label="${isSingle ? A : country.title}"
                    role="${isSingle ? "presentation" : A}"
                  >
                    ${country.locations.map(
          (location) => b`<li role="${isSingle ? "presentation" : A}">
                          <a href=${o(location.link.href)}>${location.title}</a>
                        </li>`
        )}
                  </ul>`;
      })}
            </div>`
    )}
      </div>
    `;
  }
};
JbLocationOverview.styles = [reset_css_default, jb_location_overview_css_default];
__decorateClass([
  n({ type: Array })
], JbLocationOverview.prototype, "regions", 2);
JbLocationOverview = __decorateClass([
  customElement("jb-location-overview")
], JbLocationOverview);

export {
  JbLocationOverview
};
